export const formatRubles = (value: number): string => {
  return value.toFixed(2).replace(".", ",") + " ₽";
};

